import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL, API_FILE_URL } from "../../api/config";
import { fileUrl } from "../../i18n/i18n";
import { clean } from "../../utils/strings";

class ShopGridV1 extends Component {
  state = {
    allProducts: [], // Store all products here
    products: [], // Store filtered/paginated products for display
    total: 0,
    page: 1,
    limit: 10,
    loading: true,
    search: "",
    selectedCategory: null,
  };

  componentDidMount() {
    const selectedFromProps = this.props.selectedCategoryFromLink;
    // Initial fetch of ALL data
    this.fetchAllProducts().then(() => {
      if (selectedFromProps) {
        this.setState({ selectedCategory: selectedFromProps }, () => {
          this.updateView();
        });
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.selectedCategoryFromLink !== prevProps.selectedCategoryFromLink
    ) {
      this.setState(
        {
          selectedCategory: this.props.selectedCategoryFromLink,
          page: 1,
        },
        () => {
          this.updateView();
        },
      );
    }
  }

  // Fetch ALL products once
  fetchAllProducts = async () => {
    this.setState({ loading: true });
    try {
      // Create a specific endpoint or use existing one with no limits if supported.
      // Based on conversation, we use list-no-filter or similar if available,
      // or just list with high limit if we can't change backend nicely.
      // The user approved plan to use /product/list-no-filter
      const res = await axios.get(`${API_BASE_URL}/product/list-no-filter`);
      // Assuming list-no-filter returns array directly or { data: [] }
      // Checking ProductController.findAllNoFilter logic: returns array directly in res.data or inside res.data.data?
      // ProductController says: responseHandler(res, 200, "...", products); -> usually { success, message, data: products }
      const allProducts = res.data?.data || [];

      this.setState(
        {
          allProducts,
          loading: false,
        },
        this.updateView,
      ); // Initial view update
    } catch (err) {
      console.error("Product fetch error:", err);
      this.setState({ loading: false });
    }
  };

  // Logic to Filter -> Sort -> Paginate from existing state.allProducts
  updateView = () => {
    const { allProducts, page, limit, search, selectedCategory } = this.state;

    // 1. Filter
    let filtered = allProducts.filter((p) => {
      // Category Filter
      // We check if mainCategory matches OR matches any in categories array
      // Note: p.mainCategory might be object or ID depending on population.
      // Client side we need to be robust.
      // If populated: p.mainCategory._id. If not: p.mainCategory (string).
      if (selectedCategory) {
        const mainCatId = p.mainCategory?._id || p.mainCategory;
        const catIds = (p.categories || []).map((c) => c._id || c);

        const matchesMain = String(mainCatId) === String(selectedCategory);
        const matchesSub = catIds.some(
          (id) => String(id) === String(selectedCategory),
        );

        if (!matchesMain && !matchesSub) return false;
      }

      // Search Filter
      if (search?.trim()) {
        const term = search.trim().toLowerCase();
        // Assuming translations.tr.name exists
        const nameTr = p.translations?.tr?.name?.toLowerCase() || "";
        const nameEn = p.translations?.en?.name?.toLowerCase() || "";
        if (!nameTr.includes(term) && !nameEn.includes(term)) return false;
      }

      // Status Filter (if needed, usually we only fetch status=true from backend)
      // If list-no-filter returns logic, we might need to filter status==true if not already done.
      // Controller findAllNoFilter usually implies "all" but repository might filter.
      // Check repository: findAllNoFilter does ProductModel.find() -> returns hidden ones too?
      // Repository: await ProductModel.find()... so yes it returns ALL.
      // We should filter for status === true
      if (p.status === false) return false;

      return true;
    });

    // 2. Sort
    filtered.sort((a, b) => {
      const orderA = Number(a.order) || 0;
      const orderB = Number(b.order) || 0;

      // 1. Priority: Order > 0 comes first (Ascending: 1, 2, 3...)
      const isPriorityA = orderA > 0;
      const isPriorityB = orderB > 0;

      if (isPriorityA && !isPriorityB) return -1;
      if (!isPriorityA && isPriorityB) return 1;

      if (isPriorityA && isPriorityB) {
        return orderA - orderB;
      }

      // 3. Both are default (0) -> Sort by CreatedAt DESC
      const dateA = new Date(a.createdAt).getTime();
      const dateB = new Date(b.createdAt).getTime();
      return dateB - dateA;
    });

    // 3. Paginate
    const total = filtered.length;
    // ensure page is valid
    const totalPages = Math.ceil(total / limit) || 1;
    let validPage = page;
    if (validPage > totalPages) validPage = 1;

    const startIndex = (validPage - 1) * limit;
    const endIndex = startIndex + limit;
    const paginatedProducts = filtered.slice(startIndex, endIndex);

    this.setState({
      products: paginatedProducts,
      total,
      page: validPage,
    });
  };

  // Replace fetchProducts with a call to updateView (shim for any other method calling it)
  // Actually we should just remove fetchProducts and update callers.
  // But to be safe and stick to "methods", let's update handlers.

  handlePageChange = (page) => {
    // Just update state, updateView will handle logic
    // We don't check totalPages here strictly because updateView auto-corrects or we can just update state.
    this.setState({ page }, this.updateView);
  };

  handleSearchSubmit = (e) => {
    e.preventDefault();
    this.setState({ page: 1 }, this.updateView);
  };

  handleCategoryClick = (categoryId) => {
    this.setState(
      {
        selectedCategory: categoryId,
        page: 1,
      },
      this.updateView,
    );
  };

  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    const { products, page, total, limit, loading, search, selectedCategory } =
      this.state;
    const totalPages = Math.ceil(total / limit) || 1;
    const lang = this.props.lang || "tr";
    const { categories, icon } = this.props;

    return (
      <div className="ltn__product-area ltn__product-gutter">
        <div className="container">
          <div className="row">
            {/* SOL: Liste */}
            <div className="col-lg-8 mb-100">
              <div className="ltn__shop-options">
                <div className="row">
                  <div className="col-lg-1">
                    <div className="ltn__grid-list-tab-menu ">
                      <div className="nav">
                        <a
                          className="active show"
                          data-bs-toggle="tab"
                          href="#liton_product_grid"
                        >
                          <i className="fas fa-th-large" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-11">
                    {/* Search Widget */}
                    <div className="ltn__search-widget mb-30">
                      <form onSubmit={this.handleSearchSubmit}>
                        <input
                          type="text"
                          name="search"
                          placeholder={
                            lang === "tr" ? "Ürün Ara..." : "Search product..."
                          }
                          value={search}
                          onChange={(e) =>
                            this.setState({ search: e.target.value })
                          }
                        />
                        <button
                          type={search.trim() ? "button" : "submit"}
                          onClick={
                            search.trim()
                              ? () =>
                                  this.setState({ search: "" }, () =>
                                    this.fetchProducts(1),
                                  )
                              : undefined
                          }
                        >
                          {search.trim() ? (
                            <i className="fas fa-times" />
                          ) : (
                            <i className="fas fa-search" />
                          )}
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              <div className="tab-content">
                <div
                  className="tab-pane fade active show"
                  id="liton_product_grid"
                >
                  <div className="ltn__product-tab-content-inner ltn__product-grid-view">
                    <div className="row">
                      {loading ? (
                        <div className="text-center">Yükleniyor...</div>
                      ) : products.length === 0 ? (
                        <div className="text-center">Kayıt bulunamadı.</div>
                      ) : (
                        products.map((item) => {
                          const t =
                            item?.translations?.[lang] ||
                            item?.translations?.tr ||
                            item?.translations?.en ||
                            {};
                          const name = clean(t.name) || "Ürün Adı";
                          const coverPath = clean(item?.cover);
                          const cover = coverPath
                            ? fileUrl(API_FILE_URL, coverPath)
                            : publicUrl + "assets/img/product-3/1.jpg";
                          const slug = clean(item?.slug);
                          return (
                            <div
                              className="col-xl-6 col-sm-6 col-12"
                              key={item.id}
                            >
                              <div className="ltn__product-item ltn__product-item-4 ltn__product-item-5 text-center---">
                                <div
                                  className="product-img go-top"
                                  style={{ textAlign: "center" }}
                                >
                                  <Link to={`/urunler/${slug}`}>
                                    <img
                                      src={cover}
                                      alt={name}
                                      style={{ maxHeight: 195 }}
                                    />
                                  </Link>
                                  <div className="real-estate-agent">
                                    <div className="agent-img">
                                      <img
                                        src={icon}
                                        alt="Safkar"
                                        style={{ border: "none" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="product-info"
                                  style={{ paddingTop: 0 }}
                                >
                                  <span style={{ fontSize: 14 }}>
                                    Kategori Adı
                                  </span>
                                  <h2 className="product-title go-top">
                                    <Link to={`/urunler/${slug}`}>{name}</Link>
                                  </h2>
                                </div>
                                <div className="product-info-bottom">
                                  <Link
                                    to={`/urunler/${slug}`}
                                    className="underline-link"
                                  >
                                    {lang === "tr"
                                      ? "Ürünü İncele"
                                      : "View Product"}
                                  </Link>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="ltn__pagination-area text-center">
                  <div className="ltn__pagination">
                    <ul>
                      {/* Prev */}
                      <li>
                        <a
                          href="#!"
                          onClick={(e) => {
                            e.preventDefault();
                            this.handlePageChange(page - 1);
                          }}
                          className={page === 1 ? "disabled" : ""}
                        >
                          <i className="fas fa-angle-double-left" />
                        </a>
                      </li>

                      {/* Pages */}
                      {[...Array(totalPages)].map((_, i) => (
                        <li key={i} className={page === i + 1 ? "active" : ""}>
                          <a
                            href="#!"
                            onClick={(e) => {
                              e.preventDefault();
                              this.handlePageChange(i + 1);
                            }}
                          >
                            {i + 1}
                          </a>
                        </li>
                      ))}

                      {/* Next */}
                      <li>
                        <a
                          href="#!"
                          onClick={(e) => {
                            e.preventDefault();
                            this.handlePageChange(page + 1);
                          }}
                          className={page === totalPages ? "disabled" : ""}
                        >
                          <i className="fas fa-angle-double-right" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>

            {/* SAĞ: Sidebar */}
            <div className="col-lg-4 mb-100">
              <aside className="sidebar ltn__shop-sidebar">
                <div className="widget ltn__menu-widget">
                  <h4 className="ltn__widget-title ltn__widget-title-border">
                    {lang === "tr" ? "Kategoriler" : "Categories"}
                  </h4>
                  <ul>
                    <li key="all">
                      <a
                        href="#!"
                        onClick={(e) => {
                          e.preventDefault();
                          this.handleCategoryClick(null);
                        }}
                        style={{
                          fontWeight:
                            this.state.selectedCategory === null
                              ? "bold"
                              : "normal",
                          color:
                            this.state.selectedCategory === null
                              ? "#007bff"
                              : "inherit",
                        }}
                      >
                        {lang === "tr" ? "Tüm Kategoriler" : "All Categories"}
                        <span>
                          <i className="fas fa-long-arrow-alt-right" />
                        </span>
                      </a>
                    </li>

                    {categories.map((cat) => {
                      const t = cat.translations?.[lang] || {};
                      const isActive = this.state.selectedCategory === cat.id;
                      return (
                        <li key={cat.id}>
                          <a
                            href="#!"
                            onClick={(e) => {
                              e.preventDefault();
                              this.handleCategoryClick(cat.id);
                            }}
                            style={{
                              fontWeight: isActive ? "bold" : "normal",
                              color: isActive ? "#007bff" : "inherit",
                            }}
                          >
                            {t?.name || ""}
                            <span>
                              <i className="fas fa-long-arrow-alt-right" />
                            </span>
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ShopGridV1;
